module.exports = __webpack_public_path__ + "static/media/activitiesNavbar.cfa99ec7.svg";